import React from 'react';
import { useDispatch } from 'react-redux';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from '../../../../components/CustomSwitch';
import { Helpers } from '../../../../helpers/Helpers';
import { PotTypeEnum } from '../../../../models/common/Enums';
import { storeImageViewer } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { ProductService } from '../../../../services/ProductService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody"

interface Props {
    generalInformationRef: any
    selectedProductGroup: CustomSingleSelectModel | undefined
    setSelectedProductGroup: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    name: string | undefined
    setName: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedPotType: CustomSingleSelectModel | undefined
    setSelectedPotType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isSubProduct: boolean
    setIsSubProduct: React.Dispatch<React.SetStateAction<boolean>>
    minStock: string | undefined
    setMinStock: React.Dispatch<React.SetStateAction<string | undefined>>
    isCustomActive: boolean
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    fileRef: any
    setFile: React.Dispatch<React.SetStateAction<File | undefined>>
    b64: string
    setB64: React.Dispatch<React.SetStateAction<string>>
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
    description: string | undefined
    setDescription: React.Dispatch<React.SetStateAction<string | undefined>>
    quantityInBox: string | undefined
    setQuantityInBox: React.Dispatch<React.SetStateAction<string | undefined>>
    quantityInPackage: string | undefined
    setQuantityInPackage: React.Dispatch<React.SetStateAction<string | undefined>>
    quantityInPallet: string | undefined
    setQuantityInPallet: React.Dispatch<React.SetStateAction<string | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    selectedProductGroup,
    setSelectedProductGroup,
    name,
    setName,
    selectedPotType,
    setSelectedPotType,
    isSubProduct,
    setIsSubProduct,
    minStock,
    setMinStock,
    isCustomActive,
    setIsCustomActive,
    fileRef,
    setFile,
    b64,
    setB64,
    handleFileRead,
    description,
    setDescription,
    quantityInBox,
    setQuantityInBox,
    quantityInPackage,
    setQuantityInPackage,
    quantityInPallet,
    setQuantityInPallet
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className='col-md-9'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ürün Grubu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductGroup}
                                            onChange={setSelectedProductGroup}
                                            onMenuOpen={() => ConstantService.getConstantList('PRODUCT_KIND')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Birimi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedPotType}
                                            onChange={(value) => {
                                                setQuantityInBox('');
                                                setQuantityInPackage('');
                                                setQuantityInPallet('');

                                                setSelectedPotType(value);
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name='additionalValue1'
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kutu İçi Adet</label>
                                        <CustomNumberInput
                                            isDisabled={!(PotTypeEnum.KUTU == selectedPotType?.additionalValue1 || PotTypeEnum.KOLI == selectedPotType?.additionalValue1 || PotTypeEnum.PALET == selectedPotType?.additionalValue1)}
                                            value={quantityInBox}
                                            setValue={setQuantityInBox}
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Koli İçi Adet</label>
                                        <CustomNumberInput
                                            isDisabled={!(PotTypeEnum.KUTU == selectedPotType?.additionalValue1 || PotTypeEnum.KOLI == selectedPotType?.additionalValue1 || PotTypeEnum.PALET == selectedPotType?.additionalValue1)}
                                            value={quantityInPackage}
                                            setValue={setQuantityInPackage}
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Palet İçi Adet</label>
                                        <CustomNumberInput
                                            isDisabled={!(PotTypeEnum.KUTU == selectedPotType?.additionalValue1 || PotTypeEnum.KOLI == selectedPotType?.additionalValue1 || PotTypeEnum.PALET == selectedPotType?.additionalValue1)}
                                            value={quantityInPallet}
                                            setValue={setQuantityInPallet}
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Alt Ürün Mü?</label>

                                        <CustomSwitch isActive={isSubProduct} setIsActive={setIsSubProduct} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ad</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Min. Stok</label>

                                        <CustomNumberInput value={minStock} setValue={setMinStock} />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <textarea value={description} onChange={(e) => setDescription(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: 217, resize: 'none' }} className="form-control form-control-solid" />
                                    </div>

                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Ürün Resmi</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([b64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={b64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input accept="image/*" ref={fileRef} onChange={(e) => { setFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(b64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setFile(undefined); setB64(Helpers.getPlaceholder()); fileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;